import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Sub_Category_List, Category_List } from '../../../../api/category_product/Category_Product'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import Loader from '../../../../loader/Loader'
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import parse from 'html-react-parser';
import Footer from '../../../common/footer/Footer'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSettingData } from '../../../../redux/actions/settingAction'

const SubCategory_List = () => {
    const navigate = useNavigate();
    const { slug } = useParams();
    const location = useLocation()
    const dispatch = useDispatch()
    const [activeAccordion, setActiveAccordion] = useState(null);
    const [categoryPage, setCategoryPage] = useState(null)
    const [is_loading, set_Is_Loading] = useState(false);
    const [cat_obj, set_Cat_Obj] = useState()
    const [sub_category_data, set_Sub_Category_Data] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;
    const typeId = location.state?.typeId;
    localStorage.setItem("cat_obj", cat_obj)

    const { settingData } = useSelector(
        (state) => state?.settingdata || []
    );

    useEffect(() => {
        dispatch(fetchSettingData())
    }, [dispatch]);

    useEffect(() => {
        const fetchCategoryAndSubCategory = async () => {
            if (!slug) return;

            set_Is_Loading(true);
            try {
                // Fetch category list
                const response = await Category_List();
                if (response?.data?.status === 200) {
                    const categories = response?.data?.data?.category || [];
                    const filtered_category = categories.find(
                        (cat_result) => cat_result?.slug === slug
                    );

                    if (!filtered_category && filtered_category === undefined) {
                        toast.error(`${slug} Category not found`);
                        navigate('/', { replace: true })
                        return;
                    }

                    if (filtered_category) {
                        set_Cat_Obj(filtered_category);
                        // Now fetch subcategories
                        const subResponse = await Sub_Category_List({ cat_id: filtered_category.id });
                        set_Sub_Category_Data(subResponse?.data?.data?.sub_category || []);
                        setCurrentPage(1); // Reset to first page on new category
                    } else {
                        set_Cat_Obj(null);
                        set_Sub_Category_Data([]);
                    }
                }
            } catch (error) {
                console.error("Error in chained fetch:", error);
            } finally {
                set_Is_Loading(false); // Loader only toggled once here
            }
        };

        fetchCategoryAndSubCategory();
    }, [slug]);

    const get_category_list_result_slug = localStorage.getItem("category_list_result_slug")
    // Ensure sub_category_data is always a valid array
    const validSubCategoryData = Array.isArray(sub_category_data) ? sub_category_data : [];

    const filteredSubCategoryData = validSubCategoryData.filter((item) => {
        // Case 1: If typeId is provided → only show matching typeId (including 10)
        if (typeId) return item?.type?.id === typeId;

        // Case 2: If no typeId → exclude 10
        return item?.type?.id !== 10;
    });
    // Calculate total pages safely
    const totalPages = Math.ceil(filteredSubCategoryData?.length / productsPerPage);

    // Calculate products for current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const sortedSubcategoryData = [...filteredSubCategoryData].sort((a, b) =>
        a?.title.localeCompare(b?.title)
    );

    const currentSubCategory = sortedSubcategoryData?.slice(startIndex, startIndex + productsPerPage);

    // Handle pagination (next, prev, page number click)
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const renderOtherSEO = () => {
        if (!cat_obj?.other_seo) return null;

        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(cat_obj.other_seo, "text/html");
            const links = Array.from(doc.querySelectorAll("link"));

            return links.map((link, index) => (
                <link
                    key={index}
                    rel={link.getAttribute("rel")}
                    href={link.getAttribute("href")}
                    hreflang={link.getAttribute("hreflang") || undefined}
                />
            ));
        } catch (error) {
            console.error("Failed to parse other_seo:", error);
            return null;
        }
    };
    const faqPages = cat_obj?.category_page?.filter(page => page.page_name?.toLowerCase() === "faq") || [];
    const nonFaqPages = cat_obj?.category_page?.filter(page => page.page_name?.toLowerCase() !== "faq") || [];

    // Set a unique "FAQ" tab ID
    const FAQ_TAB_ID = "faq-tab";

    const toggleAccordion = (id) => {
        setActiveAccordion(id === activeAccordion ? null : id);
    };

    // category page controls
    const handleCategoryPage = (id) => {
        if (categoryPage == id) {
            setCategoryPage(null)
        } else {
            setCategoryPage(id)
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>{cat_obj?.meta_title || "Category"}</title>
                <meta name="description" content={cat_obj?.meta_desc
                    || "description"} />

                {/* {cat_obj?.other_seo} */}

                <link rel="canonical" href={`${WEB_DOMAIN_KEY}${cat_obj?.slug}`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}${cat_obj?.slug}`} />
            </Helmet>

            <div>
                {/* <----- Header section's ---------> */}
                <Header />
                {
                    is_loading ? (
                        <Loader />
                    ) : (
                        <>
                            {/* <------ Category main banner section's --------> */}
                            {/* <Category_Main_Banner data={category_list_result} /> */}
                            <div className={`${cat_obj?.banner_image ? "block" : "hidden"} relative`}>
                                <img src={`${IMG_BASE_URL}${cat_obj?.banner_image}`} alt={cat_obj?.image_alt} className='w-full h-[300px] object-cover' />

                                {/* category pages listing */}
                                <div className='absolute bottom-2 items-center w-full '>
                                    <ul className="flex flex-wrap gap-8 mt-3 w-full items-center justify-center">
                                        {/* Non-FAQ Tabs */}
                                        {nonFaqPages.map((category_page_result) => (
                                            <li
                                                key={category_page_result?.id}
                                                onClick={() => handleCategoryPage(category_page_result?.id)}
                                            >
                                                <span
                                                    className={`${categoryPage === category_page_result?.id
                                                        ? "text-red-800"
                                                        : "text-dark"
                                                        } font-semibold text-[12px] capitalize cursor-pointer hover:text-red-800`}
                                                >
                                                    {category_page_result?.page_name}
                                                </span>
                                            </li>
                                        ))}

                                        {/* FAQ Tab (only one shown) */}
                                        {faqPages.length > 0 && (
                                            <li onClick={() => handleCategoryPage(FAQ_TAB_ID)}>
                                                <span
                                                    className={`${categoryPage === FAQ_TAB_ID
                                                        ? "text-red-800"
                                                        : "text-dark"
                                                        } font-semibold text-[13px] capitalize cursor-pointer hover:text-red-800`}
                                                >
                                                    FAQ
                                                </span>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            {/* category_pages */}

                            {cat_obj?.category_page?.length > 0 && (
                                <section className={`bg-white ${categoryPage ? "block" : "hidden"}`}>
                                    <div className="mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <div className="flex flex-wrap w-full">
                                            <div className="w-full mt-4 bg-white">
                                                {/* Non-FAQ pages */}
                                                {nonFaqPages.map((page) => {
                                                    const isActive = categoryPage === page.id;
                                                    let imageList = [];

                                                    try {
                                                        imageList = Array.isArray(page.image)
                                                            ? page.image
                                                            : JSON.parse(page.image || "[]");
                                                    } catch (err) {
                                                        console.error(
                                                            "Error parsing image JSON for page:",
                                                            page.page_name,
                                                            err
                                                        );
                                                    }

                                                    return (
                                                        <div
                                                            key={page.id}
                                                            className={`bg-white px-6 ${!isActive ? "hidden" : "block"
                                                                }`}
                                                        >
                                                            <div className="text-dark font-semibold mb-2">
                                                                {page?.page_title}
                                                            </div>

                                                            {imageList.length > 0 && (
                                                                <div className="grid grid-cols-3 gap-5">
                                                                    {imageList.map((img, idx) => (
                                                                        <img
                                                                            key={idx}
                                                                            src={`${IMG_BASE_URL}${img}`}
                                                                            alt={`Page ${page.page_name} Image ${idx}`}
                                                                            className="rounded-lg w-full object-cover"
                                                                        />
                                                                    ))}
                                                                </div>
                                                            )}

                                                            {page.description && (
                                                                <div
                                                                    className="sub__title text-gray-900 text-sm prose prose-sm max-w-none product_about_desc"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: page.description,
                                                                    }}
                                                                />
                                                            )}
                                                        </div>
                                                    );
                                                })}

                                                {/* FAQ Accordion Page (One Combined Section) */}
                                                {faqPages.length > 0 && categoryPage === FAQ_TAB_ID && (
                                                    <div className="bg-white px-6">

                                                        <div className="accordion space-y-2">
                                                            {faqPages.map((faq, idx) => (
                                                                <>
                                                                    <div id="accordion-collapse-heading-1" onClick={() => toggleAccordion(faq?.id)}>
                                                                        <button type="button" className="flex items-center justify-between w-full border-b border-gray-300 py-3 font-semibold text-[14px] focus:outline-0" data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1">
                                                                            <span>{faq?.page_title}</span>
                                                                            <svg data-accordion-icon className={`size-2 shrink-0 ${activeAccordion == faq?.id ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                    <div id="accordion-collapse-body-1" className={`${activeAccordion == faq?.id ? 'block' : 'hidden'}`} aria-labelledby="accordion-collapse-heading-1">
                                                                        <div className="py-3 pt-1">
                                                                            <div className="w-full">
                                                                                <div id="gi-spt-nav-info" className="tab-single-pane">
                                                                                    <div className="sub__title text-gray-800 text-[13px] font-medium" dangerouslySetInnerHTML={{ __html: ` ${faq?.description} ` }} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}
                            <section className="gi-category py-[40px] max-[767px]:py-[0px]">
                                <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                    <div className="flex flex-wrap w-full">
                                        <div className="gi-shop-rightside min-[992px]:w-[100%] max-[767px]:pt-[30px] min-[992px]:w-[100%] min-[768px]:w-full w-full px-[12px]">
                                            <div className="gi-pro-list-top text-[14px] mb-8">
                                                <div className="mx-auto w-full gi-grid-list text-center mb-2">
                                                    <h1 className="uppercase text-2xl  text-gray-900 font-bold">{cat_obj?.heading}</h1>
                                                </div>
                                                <div className="sub__title text-gray-900 ">{cat_obj?.sort_description && parse(cat_obj?.sort_description)}</div>
                                            </div>

                                            <div className="shop-pro-content">
                                                <div className="shop-pro-inner grid md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                                    {currentSubCategory?.map((sub_category_result) => (
                                                        <div key={sub_category_result?.id} onClick={() =>
                                                            navigate(`/${cat_obj?.slug}/${sub_category_result?.slug}`)
                                                        } >
                                                            <div className="gi-product-inner bg-white rounded-lg relative scale-100 hover:shadow-lg shadow_cus hover:scale-102 hover:z-10 transition-all duration-[0.3s] ease delay-[0s]">
                                                                <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative pt-3 md:pt-5">
                                                                    <div className="gi-pro-image overflow-hidden">
                                                                        <Link to={`/${cat_obj?.slug}/${sub_category_result?.slug}`} className="image productimg7 relative block">
                                                                            <img className="main-image object-contain aspect-[calc(4*3+1)/6] mx-auto transition-all duration-[0.3s] ease delay-[0s]"
                                                                                src={`${IMG_BASE_URL}${sub_category_result?.image}`} alt={sub_category_result?.image_alt} />
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                                <div className="mx-auto h-1 bg-gray-100 rounded-[100%] w-[70%]"></div>
                                                                <div className="gi-pro-content h-full pt-3 px-3 relative z-[10] flex flex-col text-center pb-5">
                                                                    <h2 className="text-grat-800 text-[15px] line-clamp-1 font-semibold capitalize">{sub_category_result?.title}</h2>

                                                                    <div className="flex flex-col mt-3 justify-center gap-4 items-center">
                                                                        <button type="button" className="text-[12px] uppercase border border-gray-200 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300">View More</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>

                                                {/* Pagination Controls */}
                                                <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                    <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, filteredSubCategoryData?.length)} of {filteredSubCategoryData?.length} item(s)</span>
                                                    <ul className="gi-pro-pagination-inner flex">
                                                        <li>
                                                            <button onClick={handlePrev} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                                Prev
                                                            </button>
                                                        </li>

                                                        {[...Array(totalPages).keys()].map((page) => (
                                                            <li key={page} className="inline-block float-left mr-[5px]">
                                                                <button
                                                                    onClick={() => handlePageChange(page + 1)}
                                                                    className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                                                                    text-[#777] leading-[32px] bg-[#eee] flex text-center align-top 
                                                                    text-[16px] justify-center items-center rounded-[5px]
                                                                     ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}
                                                                >
                                                                    {page + 1}
                                                                </button>
                                                            </li>
                                                        ))}

                                                        <li>
                                                            <button onClick={handleNext} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                                Next
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="sub__title text-gray-900 mt-3">{cat_obj?.description && parse(cat_obj?.description)}</div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div>
                                {settingData && settingData[0]?.certificate_image && (
                                    <img src={`${IMG_BASE_URL}${settingData[0]?.certificate_image}`} alt="certificate" className='w-full' />
                                )}
                            </div>
                        </>
                    )
                }
                <Footer />
            </div>

        </>
    )
}

export default SubCategory_List